<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { CONTENT_TYPES } from 'shared/constants/contentType';

const props = defineProps({
  message: {
    type: Object,
    required: true,
  },
});

const getCsatSurveyResponse = message => {
  const { contentAttributes } = message ?? {};
  const { submittedValues } = contentAttributes ?? {};
  const { csatSurveyResponse } = submittedValues ?? {};
  return csatSurveyResponse ?? null;
};

const { message } = props ?? {};

const { t } = useI18n();

// 评价卡片
const isCsatMessage = computed(
  () => message?.content && message?.contentType === CONTENT_TYPES.CSAT
);
// 是否已回复评价
const isCsatMessageReplied = computed(() => getCsatSurveyResponse(message));
// 消息卡片
const isCardMessage = computed(
  () => message?.content && message?.contentType === CONTENT_TYPES.CARD
);
</script>

<template>
  <span v-if="isCsatMessage">
    <!-- 有评价时 -->
    <span v-if="isCsatMessageReplied">
      {{ t('CHAT_LIST.ATTACHMENTS.csat.CONTENT') }}
    </span>
    <!-- 没有评价时 -->
    <span v-else>
      {{ t('CHAT_LIST.ATTACHMENTS.csat.CONTENT-WAITING') }}
    </span>
  </span>
  <span v-else-if="isCardMessage">
    {{ t('CHAT_LIST.ATTACHMENTS.card.CONTENT') }}
  </span>
  <template v-else><slot /></template>
</template>
